export default __webpack_public_path__ + "static/media/sample.aebd184e.png";